<template>
  <div class="container">
    <div class="row text--base">
      <GridModal v-if="gridModalTitle" :content="gridModalTitle" />
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import GridModal from '@/components/content/chapter2/GridModal.vue';

export default {
  name: 'App6Grid',
  components: {
    GridModal,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    gridModalTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'grid-modal-apps') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>